"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticlePage = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.find.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ArticlePage = props => {
  var _article$image, _article$image2, _article$image3;
  const {
    articles,
    t
  } = props;
  const {
    articleId
  } = (0, _reactRouter.useParams)();
  const [article, setArticle] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const found = articles.find(item => item.id == articleId);
    setArticle(found);
    document.title = t("Pages.Article.Title");
  }, [articles, articleId]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, article && /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container article-content"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3 article-heading"
  }, article.title), article.subheading && /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h5 con-heading__h5--fw400"
  }, article.subheading), /*#__PURE__*/_react.default.createElement("img", {
    src: article === null || article === void 0 || (_article$image = article.image) === null || _article$image === void 0 ? void 0 : _article$image.imageUrl,
    alt: article === null || article === void 0 || (_article$image2 = article.image) === null || _article$image2 === void 0 ? void 0 : _article$image2.imageAlt,
    key: article === null || article === void 0 || (_article$image3 = article.image) === null || _article$image3 === void 0 ? void 0 : _article$image3.imageId,
    className: "article-image"
  }), /*#__PURE__*/_react.default.createElement("div", null, article.caption && /*#__PURE__*/_react.default.createElement("p", {
    className: "article-text con-text con-text__small-medium"
  }, article.caption), article.text.map(text => /*#__PURE__*/_react.default.createElement("p", {
    key: text.id,
    className: "article-text con-text__Xtra-larger-regular ".concat(text.bold ? "con-text__Xtra-larger-regular--bold" : "", "\n                  ").concat(text.italics ? "con-text__Xtra-larger-regular--italic" : "", "\n                  ")
  }, text.text))))));
};
exports.ArticlePage = ArticlePage;
ArticlePage.propTypes = {
  articles: _propTypes.default.array,
  t: _propTypes.default.func
};